import * as COMMON from '@/constants/common';
import type { App } from 'vue';

const accessConstants: Record<string, string | Record<string, string>> = {
  ...COMMON
};

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $const(key: string): string;
  }
}

export default {
  install: (app: App): void => {
    app.config.globalProperties.$const = (key: string): string => {
      const [constant, property] = key.split('.');
      const value = accessConstants[constant];
      return typeof value === 'string' ? value : value[property];
    };
  }
};